/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContactState } from './contactTypes';

const initialState: ContactState = {
  firstName: '',
  surName: '',
  address1: '',
  address2: '',
  postCode: '',
  state: undefined,
  city: '',
  mobileNumber: '',
  email: '',
  privacyPolicy: undefined,
  updateProfile: undefined,
  businessName: '',
  firstNamePhonetic: '',
  lastNamePhonetic: '',
  customerNumber: '',
  allowPersonalEmail: undefined,
};

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    updatePostCodeInContact: (
      state,
      action: PayloadAction<{ postCode: string }>,
    ) => {
      state.postCode = action.payload.postCode;
    },
    updateContactState: (state, action: PayloadAction<ContactState>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { updatePostCodeInContact, updateContactState } =
  contactSlice.actions;

export default contactSlice.reducer;
